var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxtLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 4.47716 14.4772 0 20 0H60L90 30V90C90 95.5228 85.5228 100 80 100H20C14.4772 100 10 95.5228 10 90V10Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60 0L90 30H70C64.4772 30 60 25.5228 60 20V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7277 65.9888V63.1364H41.167V65.9888H36.1572V79.5H32.7375V65.9888H27.7277ZM46.6242 63.1364L49.9241 68.7134H50.0519L53.3678 63.1364H57.2749L52.2812 71.3182L57.3868 79.5H53.4078L50.0519 73.915H49.9241L46.5683 79.5H42.6052L47.7268 71.3182L42.7011 63.1364H46.6242ZM58.841 65.9888V63.1364H72.2803V65.9888H67.2705V79.5H63.8508V65.9888H58.841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtLg);
export default __webpack_public_path__ + "static/media/txt-lg.aba22b6b5b68a8400f87c701ddc9bcf4.svg";
export { ForwardRef as ReactComponent };